// eslint-disable-next-line no-undef
export const auth0Config = AUTH0_CONFIG;

// export default auth0Config;